
import React from 'react';
import { Button } from '@/components/ui/button';
import { BookOpen, DollarSign, UserCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AuthorQuickAccessProps {
  author: any;
}

const AuthorQuickAccess: React.FC<AuthorQuickAccessProps> = ({ author }) => {
  const navigate = useNavigate();

  if (!author) return null;

  return (
    <div>
      <h3 className="text-sm font-medium text-gray-500 mb-2">Quick Access</h3>
      <div className="grid grid-cols-1 gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(`/admin/authors/${author.id}`)}
          className="justify-start"
        >
          <UserCheck className="mr-2 h-4 w-4" />
          Author Details
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(`/admin/authors/${author.id}/books`)}
          className="justify-start"
        >
          <BookOpen className="mr-2 h-4 w-4" />
          Author Books
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(`/admin/authors/${author.id}/royalties`)}
          className="justify-start"
        >
          <DollarSign className="mr-2 h-4 w-4" />
          Author Royalties
        </Button>
      </div>
    </div>
  );
};

export default AuthorQuickAccess;
